<template>
    <div class="resource">
        <div class="resource_container">
            <div class="resource_side">
                <div class="title">文档目录</div>
                <div style="background-color: #fff; padding-left: 16px; height: 1040px;">
                    <el-scrollbar>
                        <!-- :default-expanded-keys="expandList" -->
                        <el-tree node-key="id" :default-expanded-keys="expandList" :current-node-key="defaultChecked"
                            :data="treeData" :props="defaultProps" @node-click="handleNodeClick" />
                    </el-scrollbar>
                </div>
            </div>
            <div class="resource_content">
                <div v-if="JSON.stringify(currentdetail) != '{}'">
                    <div style="height: 34px; font-size: 24px;color: #333;font-weight: 500;">
                        {{ currentdetail.title }}
                    </div>
                    <div style="margin: 13px 0px 27px;">
                        <img src="@/assets/image/clockfill.svg" alt="">
                        <span style="color: #666; font-size: 12px;margin-left:4px ;opacity: 80%;">发布时间：{{
                            handledate(currentdetail.updateTime) }}</span>
                    </div>
                    <!-- <div style="height: 867px; color: #fff; font-size: 12px; opacity: 80%;">
                    <div v-html="currentdetail.contentDetail"></div>
                </div> -->
                    <div style="height: 867px;">
                        <el-scrollbar>
                            <div class="contendetail"
                                style=" word-wrap: break-word;height: 867px; color: rgba(51, 51, 51, 0.8);  font-size: 14px;line-height: 200%;"
                                v-html="currentdetail.contentDetail"></div>
                        </el-scrollbar>
                    </div>
                </div>
                
                <div v-else-if="authCode === 99990401">
                    <el-empty :image="require('@/assets/image/empty@3x.png')" :image-size="220" description="暂无查看权限" />
                </div>
                <div v-else>
                    <el-empty :image="require('@/assets/image/empty@3x.png')" :image-size="220" description="暂无文章内容，看看其他内容吧" />
                </div>
                <div class="paging-container">
                    <el-divider />
                    <otherPage :is-control="true" @page-event="hanldlePage" :previous-text="previousdetail.title"
                        :next-text="nextdetail.title"></otherPage>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import otherPage from '@/components/otherPage'
import { ref, onBeforeMount } from 'vue'
import { documentByid } from '@/api/developer'
import { getProjectDoc } from '@/api/control'
import { handledate } from '@/utils/common.js'
import { useRoute } from 'vue-router';
const route = useRoute();
const handleNodeClick = (data) => {
    if (!data.children.length) {
        getdocumentDeatail(data.id)
    }
}
// updateTime: '2023-06-19 14:25:47', id: 4, title: '国内各城市皆可', description: '', contentDetail: '吧v东法兰克'
const treeData = ref([])
const currentdetail = ref({})
const nextdetail = ref({})
const previousdetail = ref({})
const expandList = ref([])
const defaultChecked = ref('')
const documentId = ref('')
const isfirst = ref(false)
const authCode = ref(0)
onBeforeMount(async () => {
    await getcenterdata()
    isfirst.value = true
})
//调用资源中心接口，获取数据
const getcenterdata = () => {
    let { projectId, developmentToolDocumentId, type } = route.query
    getProjectDoc({ projectId }).then(res => {
        console.log( 'res.code',res.code);
        authCode.value = res.code
        if (res.code === 200) {
            treeData.value = res.result
            documentId.value = type == 'tool' ? developmentToolDocumentId : treeData.value[0].children[0].id
            if (isfirst.value) {
                getdocumentDeatail(documentId.value)
                expandList.value = []
                expandList.value.push(documentId.value)
                defaultChecked.value = documentId.value
                isfirst.value = false
            }
        }
        // console.log(res);
    }).catch(err => { console.log(err); })
}
//根据id获取文章
const getdocumentDeatail = async (id) => {
    documentByid({ documentDirectoryId: id }).then(res => {
        if (res.code === 200) {
            let { currentDocumentDetail, previousDocument, nextDocument } = res.result
            currentdetail.value = currentDocumentDetail
            nextdetail.value = nextDocument
            previousdetail.value = previousDocument
            console.log('document', res);
        }
        if (res.code == 100) {
            currentdetail.value = {}
            nextdetail.value = {}
            previousdetail.value = {}
        }
    }).catch(err => { console.log(err); })
}
//点击上一篇下一篇
const hanldlePage = (item) => {
    let id = item == "previous" ? previousdetail.value.id : nextdetail.value.id
    if (id) {
        expandList.value = []
        expandList.value.push(id)
        defaultChecked.value = id
        getdocumentDeatail(id)
    }
    console.log(item, id);
}
const defaultProps = {
    children: 'children',
    label: 'title',
}
</script>

<style lang="scss" scoped>
$bg-color: #fff;
$pinpai-color: #386AEA;

p {
    word-wrap: break-word;
}

::v-deep .resource_content img {
    max-width: 832px;
}

::v-deep .el-empty {
    padding-top: 345px;

    p {
        font-size: 16px;
        color: #999;
        transform: translateY(-30px);
    }
}

::v-deep .el-tree-node__label {
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 超出部分隐藏 */
    text-overflow: ellipsis;
    /* 显示省略号 */
}

.contendetail {
    -webkit-user-select: none;
    /* Chrome, Safari, Opera */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* Internet Explorer */
    user-select: none;
}

@media (max-width:1200px) {
    .resource_container {
        width: calc(100vw - 80px);

        .contendetail {
            width: calc(100vw - 352px);

        }
    }
}

@media (min-width:1200px) {
    .resource_container {
        width: 1104px;

        .contendetail {
            width: 832px;
        }
    }
}

.resource {
    height: 1194px;
    background-color: #f8f8f8;

    .resource_container {
        height: 100%;
        margin: 0 auto;
        display: flex;
        padding: 24px 0px 60px;
        justify-content: space-between;

        .resource_side {
            width: 208px;
            border-radius: 4px;
            background-color: $bg-color;
            margin-right: 16px;

            .title {
                font-size: 20px;
                color: #333;
                background-color: #f2f2f2;
                font-weight: 500;
                padding: 16px;
                height: 60px;
            }
        }

        .resource_content {
            border-radius: 4px;
            flex: 1;
            padding: 32px 24px 48px;
            background-color: #fff;
            position: relative;
        }
    }
    .paging-container {
        width: 100%;
        height: 88px;
        position: absolute;
        left: 0;
        bottom: 0;
        padding: 0 24px;
    }
}

::v-deep .el-divider--horizontal {
    border-top: none;
    background-color: #33333316;
    margin: 0px 0px 40px;
}

::v-deep .el-tree {
    background-color: #fff;
}

::v-deep .is-current .el-tree-node__content {
    background-color: #fff !important;
}

::v-deep .el-tree-node__content {
    background-color: #fff !important;
}

::v-deep .el-tree-node__label {
    color: #333;
    font-size: 12px;
    font-weight: 500;
}

::v-deep .is-current>.el-tree-node__content>.el-tree-node__label {
    color: #386AEA;
}

::v-deep .el-tree-node :hover {
    background-color: #fff;
}

::v-deep .el-tree-node {
    margin-top: 15px;
}

::v-deep .el-tree-node__children {
    .el-tree-node {
        margin-top: 10px;

        .el-tree-node__content {
            padding-left: 0px !important;
        }
    }

    .el-tree-node__label {
        font-weight: 500;
    }
}

::v-deep .el-tree-node__children .el-tree-node:nth-child(1) {
    margin-top: 16px;
}

::v-deep i.el-icon.el-tree-node__expand-icon {
    color: #333;
}

::v-deep i.el-icon.el-tree-node__expand-icon.is-leaf {
    color: transparent;
}</style>